<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div v-scroll-spy>
      <!-- Faqs start -->
      <section>
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="text-center mb-5">
                <div class="small-title">Request ID starting</div>
                <h2>{{ log.key }}</h2>
                <h4>Duration {{ log.duration }} milliseconds</h4>
                <h6>(Max {{ log.maxDuration }} milliseconds)</h6>
              </div>
            </div>
          </div>
          <!-- end row -->
          <div class="row">
            <div class="col-lg-12" style="display: block">
              <div class="vertical-nav">
                <b-tabs
                  pills
                  card
                  vertical
                  nav-wrapper-class="col-md-3"
                  content-class="col-md-9 no-padding"
                >
                  <template v-if="log && log.timelines">
                    <b-tab
                      v-for="(item, key) in log.timelines"
                      :key="item._id"
                      :active="key == 0 ? true : false"
                      class="no-padding"
                    >
                      <template v-slot:title>
                        <div class="row">
                          <div class="col-md-12" style="text-align: right">
                            <i
                              :id="`tooltip-target-${item._id}`"
                              class="mdi mdi-alert-circle-outline mb-12"
                            ></i>
                            <b-tooltip :target="`tooltip-target-${item._id}`">
                              {{ getEstimatedDuration(item) }}
                            </b-tooltip>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <i
                              class="bx bx-right-arrow-circle nav-icon d-block mb-2"
                            ></i
                            >{{ getEstimatedDurationShort(item) }}
                            <p
                              class="font-weight-bold mb-0"
                              style="font-size: 9px"
                            >
                              {{ item._index }}
                            </p>
                            <p class="font-weight-bold mb-0">
                              {{ item._source.duration }} ms
                            </p>
                          </div>
                        </div>
                      </template>
                      <b-card-text>
                        <div class="card">
                          <div class="card-body">
                            <h4
                              class="card-title mb-4"
                              v-if="item._source.fields.RequestId"
                            >
                              Request ID: {{ item._source.fields.RequestId }}
                            </h4>
                            <h5 class="card-title mb-4">
                              Path:
                              {{ item._source.logs[0]._source.fields.Method }}
                              {{ item._source.logs[0]._source.fields.Path }}
                            </h5>
                            <div role="tablist" v-if="item._source.logs">
                              <b-card
                                v-for="(log, index) in item._source.logs"
                                :key="index"
                                no-body
                                class="custom-accordion shadow-none mb-3"
                              >
                                <b-card-header
                                  header-tag="header"
                                  role="tab"
                                  style="padding: 12px 0 0 0"
                                >
                                  <a
                                    href="javascript: void(0);"
                                    class="accordion-list collapsed"
                                    v-b-toggle="'accordion-' + index"
                                  >
                                    <div class="container">
                                      <div class="row">
                                        <div class="col-lg-3 col-md-5">
                                          <div
                                            style="
                                              display: contents;
                                              text-align: center;
                                            "
                                          >
                                            <b-alert
                                              :id="`tooltip-b-alert-${log._id}`"
                                              show
                                              :variant="
                                                backgroundColor(
                                                  item._source.logs,
                                                  log,
                                                  index
                                                )
                                              "
                                            >
                                              {{
                                                log._source["@timestamp"]
                                                  | formatTime
                                              }}
                                            </b-alert>
                                            <b-tooltip
                                              :target="`tooltip-b-alert-${log._id}`"
                                            >
                                              {{
                                                log._source["@timestamp"]
                                                  | formatDate
                                              }}
                                            </b-tooltip>
                                          </div>
                                        </div>
                                        <div class="col-lg-8 col-md-6">
                                          {{
                                            log._source.message
                                              | truncate(50, "...")
                                          }}
                                        </div>
                                        <div
                                          class="col-lg-1 col-md-1"
                                          style="text-align: right"
                                        >
                                          <i
                                            class="mdi mdi-minus accor-plus-icon"
                                          ></i>
                                        </div>
                                      </div>
                                    </div>
                                  </a>
                                  <div
                                    style="
                                      position: absolute;
                                      top: 15px;
                                      left: 20px;
                                    "
                                  >
                                    <i
                                      class="mdi mdi-clipboard-text"
                                      style="font-size: 1.8rem; cursor: pointer"
                                      @click="doCopy(log._source.message)"
                                    ></i>
                                  </div>
                                </b-card-header>
                                <b-collapse
                                  :id="'accordion-' + index"
                                  accordion="my-accordion"
                                  role="tabpanel"
                                >
                                  <b-card-body>
                                    <b-card
                                      header-class="bg-transparent border-primary"
                                      class="border border-primary"
                                    >
                                      <template v-slot:header>
                                        <h5 class="my-0 text-primary">
                                          <i class="mdi mdi-information-outline"
                                            >Request information</i
                                          >
                                        </h5>
                                      </template>
                                      <div class="table-responsive">
                                        <table class="table table-dark mb-0">
                                          <thead>
                                            <tr>
                                              <th>#</th>
                                              <th>Key</th>
                                              <th>Value</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <template
                                              v-for="(
                                                value1, key1, index1
                                              ) in log._source"
                                            >
                                              <tr
                                                :key="key1"
                                                v-if="
                                                  typeof value1 !== 'object'
                                                "
                                              >
                                                <th scope="row">
                                                  {{ index1 + 1 }}
                                                </th>
                                                <td>{{ key1 }}</td>
                                                <td>{{ value1 }}</td>
                                              </tr>
                                              <template v-else>
                                                <template
                                                  v-for="(
                                                    value2, key2, index2
                                                  ) in value1"
                                                >
                                                  <tr
                                                    :key="key2"
                                                    v-if="
                                                      typeof value2 !== 'object'
                                                    "
                                                  >
                                                    <th scope="row">
                                                      {{ index1 + index2 + 1 }}
                                                    </th>
                                                    <td>
                                                      {{ key1 }}.{{ key2 }}
                                                    </td>
                                                    <td>{{ value2 }}</td>
                                                  </tr>
                                                  <template v-else>
                                                    <template
                                                      v-for="(
                                                        value3, key3, index3
                                                      ) in value2"
                                                    >
                                                      <tr
                                                        :key="key3"
                                                        v-if="
                                                          typeof value3 !==
                                                          'object'
                                                        "
                                                      >
                                                        <th scope="row">
                                                          {{
                                                            index1 +
                                                            index2 +
                                                            index3 +
                                                            2
                                                          }}
                                                        </th>
                                                        <td>
                                                          {{ key1 }}.{{
                                                            key2
                                                          }}.{{ key3 }}
                                                        </td>
                                                        <td>{{ value3 }}</td>
                                                      </tr>
                                                    </template>
                                                  </template>
                                                </template>
                                              </template>
                                            </template>
                                          </tbody>
                                        </table>
                                      </div>
                                    </b-card>
                                  </b-card-body>
                                </b-collapse>
                              </b-card>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                  </template>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
      <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
      <!-- end Faqs start -->
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
const axios = require("axios").default;
import Swal from "sweetalert2";
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "View System Log",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loading,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      id: "",
      title: "View Log",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "System Log",
          href: "/system-logs",
        },
        {
          text: "Log",
          active: true,
        },
      ],
      log: {},
      test: [],
    };
  },
  created: function () {
    this.id = decodeURIComponent(this.$route.params.id);
  },
  mounted() {
    this.onLoad();
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "";
      return moment(String(value)).format("DD-MM-YYYY HH:mm:ss.SSS");
    },
    formatTime: function (value) {
      if (!value) return "";
      return moment(String(value)).format("HH:mm:ss.SSS");
    },
    truncate: function (text, length, suffix) {
      if (text.length > length) return text.substring(0, length) + suffix;
      else return text;
    },
  },
  methods: {
    onLoad() {
      if (this.id) {
        axios
          .get(`${process.env.VUE_APP_BASE_API_WATCHDOG}/logs/${this.id}`)
          .then((response) => {
            this.log = response.data;
          //  console.log(this.log);
          })
          .catch((error) => {
            console.log(error);
            this.errored = true;
            this.isLoading = false;
          })
          .finally(() => (this.isLoading = false));
      }
    },
    backgroundColor(logs, log, index) {
      let variant = "primary";
      if (index < logs.length - 1) {
        let alterTime = moment(logs[index + 1]._source["@timestamp"]);
        let myTime = moment(log._source["@timestamp"]);
        let duration = alterTime.diff(myTime);
        switch (true) {
          case duration > 5000:
            variant = "danger";
            break;
          case duration > 1000:
            variant = "warning";
            break;
          default:
            break;
        }
      }
      return variant;
    },
    parseDateTimeSpan(dateValue) {
      var date = new Date(dateValue);
      var s = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}`;
      return s;
    },
    getEstimatedDurationShort(logs) {
      if (logs._source && logs._source.logs) {
        if (logs._source.logs.length) {
          var _first = Object.values(logs._source.logs)[0];
          if (logs._source.logs.length > 1) {
            var _last = Object.values(logs._source.logs)[
              logs._source.logs.length - 1
            ];
            return `${this.formatTime(
              _first._source["@timestamp"]
            )} ~ ${this.formatTime(_last._source["@timestamp"])}`;
          } else {
            return `${this.formatTime(_first._source["@timestamp"])}`;
          }
        }
      }
      return "";
    },
    getEstimatedDuration(logs) {
      if (logs._source && logs._source.logs) {
        if (logs._source.logs.length) {
          var _first = Object.values(logs._source.logs)[0];
          if (logs._source.logs.length > 1) {
            var _last = Object.values(logs._source.logs)[
              logs._source.logs.length - 1
            ];
            return `${this.formatDate(
              _first._source["@timestamp"]
            )} ~ ${this.formatDate(_last._source["@timestamp"])}`;
          } else {
            return `${this.formatDate(_first._source["@timestamp"])}`;
          }
        }
      }
      return "";
    },
    doCopy: function (message) {
      let _this = this;
      this.$copyText(message).then(
        function () {
          _this.$utils.notification(
            "success",
            "Code copied to clipboard.",
            1500
          );
        },
        function () {
          _this.$utils.notification(
            "error",
            "Sorry, unable to copy to clipboard.",
            1500
          );
        }
      );
    },
    // getEstimatedDurationShort(logs) {
    //   if(logs._source && logs._source.logs) {
    //     if(logs._source.logs.length) {
    //       var _first = Object.values(logs._source.logs)[0];
    //       var date = new Date();
    //       if(logs._source.logs.length > 1) {
    //         var _last = Object.values(logs._source.logs)[logs._source.logs.length - 1];
    //         console.log('_last', _last);
    //         date = new Date(_first._source['@timestamp']);
    //         var from = `${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}`;
    //         date = new Date(_last._source['@timestamp']);
    //         var to = `${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}`;
    //         return `${from} ~ ${to}`;
    //       }else{
    //         date = new Date(_first._source['@timestamp']);
    //         var from2 = `${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}`;
    //         return `${from2}`;
    //       }
    //     }
    //   }
    //   return '';
    // },
    // getEstimatedDuration(logs) {
    //   if(logs._source && logs._source.logs) {
    //     if(logs._source.logs.length) {
    //       var _first = Object.values(logs._source.logs)[0];
    //       var date = new Date();
    //       if(logs._source.logs.length > 1) {
    //         var _last = Object.values(logs._source.logs)[logs._source.logs.length - 1];
    //         date = new Date(_first._source['@timestamp']);
    //         var from = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}`;
    //         date = new Date(_last._source['@timestamp']);
    //         var to = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}`;
    //         return `${from} ~ ${to}`;
    //       }else{
    //         date = new Date(_first._source['@timestamp']);
    //         var from2 = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}`;
    //         return `${from2}`;
    //       }
    //     }
    //   }
    //   return '';
    // },
    formatDate: function (value) {
      if (!value) return "";
      return moment(String(value)).format("DD-MM-YYYY HH:mm:ss.SSS");
    },
    formatTime: function (value) {
      if (!value) return "";
      return moment(String(value)).format("HH:mm:ss.SSS");
    },
  },
};
</script>

<style scoped>
.no-padding {
  padding: 0;
}
.b-tooltip:not([style*="transform"]) {
  top: 0;
}
</style>

<style>
.vertical-nav .nav .nav-link {
  margin-bottom: 0;
}

/* li.nav-item {
  border: 1px solid #b0cace;
  border-radius: 5px;
  margin-bottom: 1px;
} */
</style>
